import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import DataGrid from '../../../../common/DataGrid/DataGrid';
import { SeriousDeleteQuestion } from '../../../../common/DeleteQuestion/SeriousDeleteQuestion.jsx';

export function UnitsTable({ units, onEditClick, onDelete }) {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        title: t('Jednotka'),
        dataIndex: 'unit',
        ellipsis: true,
      },
    ],
    [t],
  );

  return (
    <DataGrid
      rowKey={(unit) => unit.id}
      columns={columns}
      dataSource={units}
      permissionsBasic={'meteo-station'}
      uniqueTableId={'meteo-station-units-table'}
      onRowClick={onEditClick}
      onEditClick={onEditClick}
      onDelete={onDelete}
      question={
        <SeriousDeleteQuestion
          firstText={t('Naozaj chcete vymazať túto jednotku?')}
          mainNotice={t(
            'S jednotkou sa vymažú aj VŠETKY jej atribúty a VŠETKY ich hodnoty!',
          )}
          lastText={t(
            'Prosím uistite sa, že mažete správnu jednotku, aby ste predišli nežiadúcim komplikáciam!',
          )}
        />
      }
    />
  );
}

UnitsTable.propTypes = {
  units: PropTypes.array.isRequired,
  onEditClick: PropTypes.func,
  onDelete: PropTypes.func,
};
